import { pickBy } from 'lodash';

type MappingFunction<T> = (value: T) => unknown;

/**
 * Maps defined values from source object to target object using provided transformations.
 * Only includes properties that exist (not undefined) in the source object.
 */
function mapDefinedValues<TSource extends Record<string, unknown>, TTarget>(
  source: TSource,
  mappings: Record<
    string,
    { targetKey: keyof TTarget; transform: MappingFunction<unknown> }
  >,
): Partial<TTarget> {
  const filtered = pickBy(source, (v) => v !== undefined);
  const result: Partial<TTarget> = {};

  Object.entries(mappings).forEach(([sourceKey, { targetKey, transform }]) => {
    if (sourceKey in filtered) {
      result[targetKey] = transform(
        filtered[sourceKey],
      ) as TTarget[keyof TTarget];
    }
  });

  return result;
}

export default mapDefinedValues;
